// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Service Imports
import { getMeterUsageService } from "../../actions/CommonActions/commonService";
import { getUserFeaturesService } from "../../actions/UserActions/userService";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

// Declaration
const UPGRADE = ["upgrade_locked", "price_locked"];
const HIDDEN = "hidden";
const UNLIMITED_COUNT = 1000;

export default class FeatureGating extends React.Component {
  state = {
    count: null,
  };

  componentDidMount() {
    this._checkBillingFeatureValues();
    this._getMeteredUsage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reRender !== this.props.reRender) {
      this._getMeteredUsage();
    }

    this._checkBillingFeatureValues();

    // Call the below method only when a meter based component does a action to increase/decrase the value
    if (prevProps.counterFlag !== this.props.counterFlag) {
      this._getMeteredUsage();
    }
  }

  // Fallback method to check if the billing related data is stored in localstorage
  _checkBillingFeatureValues = () => {
    const featureEntityMap = readDataFromLocalStorage("featureEntityMap");
    const userFeatures = readDataFromLocalStorage("revvsalesUserFeatures");

    if (!userFeatures) {
      getUserFeaturesService();
    }
    if (!featureEntityMap) {
      getMeterUsageService();
    }
  };

  _getMeteredUsage = () => {
    // Fetch entity map which provides alias for metered features
    const featureEntityMap = readDataFromLocalStorage("featureEntityMap");

    // Feature Name assigned from the Backend
    const featureName = this.props.name;

    // Check if its a metered or non-metered feature
    const isMetered =
      (featureEntityMap &&
        Object.prototype.hasOwnProperty.call(featureEntityMap, featureName)) ||
      false;

    if (isMetered) {
      const meteredFeatureName = featureEntityMap[featureName];
      // Fetch the updated count details of the particular feature
      getMeterUsageService(meteredFeatureName)
        .then(res => {
          this.setState({
            count: res,
          });
        })
        .catch(err =>
          console.error("FeatureGating => getMeterUsageService", err),
        );
    }
  };

  render() {
    // Fetch entity map which provides alias for metered features
    const featureEntityMap = readDataFromLocalStorage("featureEntityMap");

    // Fetch feature mappings which is based on org level
    const userFeatures = readDataFromLocalStorage("revvsalesUserFeatures");

    // Feature Name assigned from the Backend
    const featureName = this.props.name;

    // Check if backend allows the component to be displayed in the UI
    const isEnabled =
      (userFeatures &&
        Object.prototype.hasOwnProperty.call(userFeatures, featureName) &&
        userFeatures[featureName].is_enabled) ||
      false;

    // Check weather the feature should be hidden from UI or an pro/upgrade tease has to be showed instead
    const displayState =
      (userFeatures &&
        Object.prototype.hasOwnProperty.call(userFeatures, featureName) &&
        userFeatures[featureName].value) ||
      HIDDEN;

    // Check if its a metered or non-metered feature
    const isMetered =
      (featureEntityMap &&
        Object.prototype.hasOwnProperty.call(featureEntityMap, featureName)) ||
      false;

    // :: METERED FEATURE LOGIC SECTION
    //* If the feature has metered enabled for the user then execute the below logic
    if (this.state.count) {
      const LIMIT_THRESHOLD = this.props.isMeteredCounterComponent ? 1 : 0;
      const isLimitExhausted = !(
        this.state.count.limit - this.state.count.usage >
        LIMIT_THRESHOLD
      );

      // Add addition props called count(contains limit/usage) to the existing one
      const altComponent = React.Children.map(this.props.altComponent, child =>
        React.cloneElement(child, { count: this.state.count }),
      );
      const children = React.Children.map(this.props.children, child =>
        React.cloneElement(child, { count: this.state.count }),
      );

      //* If the count is unlimited then the meter component will be hidden
      if (
        this.props.isMeteredCounterComponent &&
        this.state.count.limit === UNLIMITED_COUNT
      )
        return <Fragment />;

      //* If its not unlimited, then based on usage the component is displayed
      if (isLimitExhausted) return altComponent;
      return children;
    }

    // :: NON-METERED FEATURE LOGIC SECTION
    //* If the feature is enabled for the user then show the component
    if (!isMetered && (isEnabled || this.props.ignore)) {
      return this.props.children;
    }

    //* If the feature is disabled then check should it return an alternative component, say pro popup, etc.
    if (!isMetered && !isEnabled && UPGRADE.includes(displayState)) {
      return this.props.altComponent;
    }

    //* Return a dummy component if none of the above cases satisfy
    return <Fragment />;
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/FeatureGating/index.js